import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const merchantLocationService = {
  getAllLocations,
  addLocation,
  getLocation,
  deleteLocation
};

function getAllLocations(params) {
  return apiCall("GET", apiUrls.merchants.location, null, params);
}

function addLocation(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.merchants.location;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getLocation(id) {
  return apiCall("GET", `${apiUrls.merchants.location}/${id}`);
}

function deleteLocation(id) {
  return apiCall("DELETE", `${apiUrls.merchants.location}/${id}`);
}
